import { render, staticRenderFns } from "./CommonChats.vue?vue&type=template&id=efef3e10&scoped=true&lang=pug"
import script from "./CommonChats.vue?vue&type=script&lang=js"
export * from "./CommonChats.vue?vue&type=script&lang=js"
import style0 from "./CommonChats.vue?vue&type=style&index=0&id=efef3e10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efef3e10",
  null
  
)

export default component.exports